import React from 'react';
export default function LoadingState({ label = 'Opening your workspace…' }) {
  return <div className="erp-loading" role="status" aria-live="polite"><span className="erp-spinner" aria-hidden="true" /><strong>{label}</strong><span>This may take a moment on your first visit.</span></div>;
}
